export default __webpack_public_path__ + "static/media/Arrow_white_2.19110dbc.svg";